import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import interviewService from "services/InterviewService";
import { message } from "antd";

export const initialState = {
  loadingInterview: false,
  interviews: [],
  totalRecord: 0,
  loadingCreate: false,
  loadingUpdate: false,
  createLoadingInterview: false,
  loadingInterviewById: false,
  loadingSetActive: false,
  interviewStatus: [],
  loadingInterviewStatus: false,
  loadingInterviewsByApplicationId: false,
  dataInterviewsByAppId: [],
  criteriaDetails: [],
  loadingCriteria: false,
  loadingAddCriteria: false,
  criteria: [],
  levels: [],
  loadingLevels: false,
};

export const GetInterviewSSR = createAsyncThunk(
  "/Interview/GetAllSSR",
  async (data, { rejectWithValue }) => {
    try {
      const response = await interviewService.GetInterviewSSR(data);
      if (response.success === false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CreateInterview = createAsyncThunk(
  "/Interview/Create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await interviewService.CreateInterview(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const UpdateInterview = createAsyncThunk(
  "/Interview/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await interviewService.UpdateInterview(data);

      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const AddCriteria = createAsyncThunk(
  "/Interview/AddCriteria",
  async (data, { rejectWithValue }) => {
    try {
      const response = await interviewService.AddCriteria(data);

      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetInterviewById = createAsyncThunk(
  "/Interview/GetById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await interviewService.GetInterviewById({ id });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetInterviewStatus = createAsyncThunk(
  "/Interview/GetInterviewStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await interviewService.GetInterviewStatus();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetActive = createAsyncThunk(
  "/Interview/SetIsActive",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await interviewService.SetActive({ id, status });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetLevels = createAsyncThunk(
  "/Interview/GetLevels",
  async (_, { rejectWithValue }) => {
    try {
      const response = await interviewService.GetLevels();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetCriteria = createAsyncThunk(
  "/Interview/GetCriteria",
  async (_, { rejectWithValue }) => {
    try {
      const response = await interviewService.GetCriteria();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetInterviewsByApplicationId = createAsyncThunk(
  "/Interview/GetInterviewByApplicationId",
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const response = await interviewService.GetInterviewsByApplicationId({
        applicationId,
      });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const interviewSlice = createSlice({
  name: "inteview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetInterviewSSR.pending, (state) => {
        state.loadingInterview = true;
      })
      .addCase(GetInterviewSSR.fulfilled, (state, action) => {
        state.loadingInterview = false;
        state.interviews = action.payload.data;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(GetInterviewSSR.rejected, (state, action) => {
        state.interviews = [];
        state.loadingInterview = false;
      })
      .addCase(CreateInterview.rejected, (state, action) => {
        state.createLoadingInterview = false;
      })
      .addCase(CreateInterview.pending, (state) => {
        state.createLoadingInterview = true;
      })
      .addCase(CreateInterview.fulfilled, (state, action) => {
        state.createLoadingInterview = false;
      })
      .addCase(UpdateInterview.rejected, (state, action) => {
        state.loadingloadingUpdateCreate = false;
      })
      .addCase(UpdateInterview.pending, (state) => {
        state.loadingUpdate = true;
      })
      .addCase(UpdateInterview.fulfilled, (state, action) => {
        state.loadingUpdate = false;
      })

      .addCase(SetActive.pending, (state) => {
        state.loadingSetActive = true;
      })
      .addCase(SetActive.fulfilled, (state, action) => {
        state.loadingSetActive = false;
      })
      .addCase(SetActive.rejected, (state, action) => {
        state.loadingSetActive = false;
      })
      .addCase(GetInterviewById.pending, (state) => {
        state.loadingInterviewById = true;
      })
      .addCase(GetInterviewById.fulfilled, (state, action) => {
        state.loadingInterviewById = false;
        state.criteriaDetails = action.payload.criteriaDetail;
      })
      .addCase(GetInterviewById.rejected, (state, action) => {
        state.loadingInterviewById = false;
        state.criteriaDetails = [];
      })
      .addCase(GetInterviewStatus.pending, (state) => {
        state.loadingInterviewStatus = true;
      })
      .addCase(GetInterviewStatus.fulfilled, (state, action) => {
        state.loadingInterviewStatus = false;
        state.interviewStatus = action.payload;
      })
      .addCase(GetInterviewStatus.rejected, (state, action) => {
        state.loadingInterviewStatus = false;
        state.interviewStatus = [];
      })

      .addCase(GetCriteria.pending, (state) => {
        state.loadingCriteria = true;
      })
      .addCase(GetCriteria.fulfilled, (state, action) => {
        state.loadingCriteria = false;
        state.criteria = action.payload;
      })
      .addCase(GetCriteria.rejected, (state, action) => {
        state.loadingCriteria = false;
        state.criteria = [];
      })
      .addCase(GetLevels.pending, (state) => {
        state.loadingLevels = true;
      })
      .addCase(GetLevels.fulfilled, (state, action) => {
        state.loadingLevels = false;
        state.levels = action.payload;
      })
      .addCase(GetLevels.rejected, (state, action) => {
        state.loadingLevels = false;
        state.levels = [];
      })
      .addCase(AddCriteria.rejected, (state, action) => {
        state.loadingAddCriteria = false;
      })
      .addCase(AddCriteria.pending, (state) => {
        state.loadingAddCriteria = true;
      })
      .addCase(AddCriteria.fulfilled, (state, action) => {
        state.loadingAddCriteria = false;
      })
      .addCase(GetInterviewsByApplicationId.pending, (state) => {
        state.loadingInterviewsByApplicationId = true;
      })
      .addCase(GetInterviewsByApplicationId.fulfilled, (state, action) => {
        state.loadingInterviewsByApplicationId = false;
        state.dataInterviewsByAppId = action.payload;
      })
      .addCase(GetInterviewsByApplicationId.rejected, (state, action) => {
        state.loadingInterviewsByApplicationId = false;
        state.dataInterviewsByAppId = [];
      });
  },
});

export const {} = interviewSlice.actions;

export default interviewSlice.reducer;
